"use client";

import React, { ReactNode, useEffect, useRef, useState } from "react";
import { ContainerProp, Media, descriptionObject } from "../../../global";
import TextContainer from "./textContainer";
import BoxContent from "./boxContent";
import Image from "next/image";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";
import BottomCurves from "../curves/bottomCurves";
import { getStrapiMedia } from "@/utils/api-helpers";

type BannerDescContainerProp = Omit<ContainerProp, "className"> & {
    introCard: any;
    floatingImage: any;
    imageBanner: {
        image: Media;
    };
    description: descriptionObject[];
};

export default function IntroContainer({
    data,
}: {
    data: BannerDescContainerProp;
}) {
    const floatingImgRef = useRef(null);
    const floatingImageSectionRef = useRef(null);

    // let imageSrc = data.image?.data;

    const floatingImage = getStrapiMedia(data.imageBanner.image.url);
    const introCard1To3 = data.introCard.slice(0, 3);
    const introCard4To6 = data.introCard.slice(3, 6);

    gsap.registerPlugin(ScrollTrigger);
    useGSAP(
        () => {
            const tl = gsap.timeline({
                trigger: floatingImgRef.current,
                start: "top 75%",
                toggleActions: "play reverse play reverse",
                markers: true,
                scrub: 1.05,
            });
            tl.to(floatingImgRef.current, { opacity: 1, y: 0 });
        },
        { scope: floatingImageSectionRef }
    );

    const [imageRotate, setImageRotate] = useState<any>(null);
    const [preFetchedImages, setPreFetchedImages] = useState<string[]>([]);
    const [images, setImages] = useState<any[]>([]);
    const [imageDisplay, setImageDisplay] = useState<ReactNode | null>();
    const [imageTrigger, setImageTrigger] = useState<boolean>(false);

    const imageSrc = Array.isArray(data.image) ? data.image : [];

    const sortedImageSrc = imageSrc.sort((a, b) => {
        const numA = parseInt(
            a.name.match(/\d+/g)?.join("") || "0",
            10
        );
        const numB = parseInt(
            b.name.match(/\d+/g)?.join("") || "0",
            10
        );
        return numA - numB;
    });

    // Fetch all images at once and store them in state
    useEffect(() => {
        if (preFetchedImages.length === 0) {
            Promise.all(
                sortedImageSrc.map((data) =>
                    getStrapiMedia(data.url)
                )
            )
                .then((fetchedImages) => {
                    setPreFetchedImages(fetchedImages);
                })
                .catch((error) => console.error(error));
        }
    }, [preFetchedImages.length, sortedImageSrc]);

    useEffect(() => {
        const imageComponents = preFetchedImages.map((image, i) => {
            return {
                Image: (
                    <Image
                        src={image}
                        alt="test"
                        data-index={i}
                        height={400}
                        width={400}
                        loading="lazy"
                        // onLoad={(e) => {
                        //     images.filter(
                        //         (x) => x.Image.props["data-index"] === i
                        //     )[0].Status = true;
                        //     console.log(images);
                        // }}
                    />
                ),
                // Status: false,
            };
        });

        setImages(imageComponents);
        // console.log(imageComponents);
        // onLoopImages();
    }, [preFetchedImages]);

    useEffect(() => {
        onLoopImages();
        // let i = 0;
        // let imageLength = preFetchedImages.length;

        // const rotateImages = () => {
        //     setImageRotate(images[i].Image);
        //     i = (i + 1) % imageLength;
        // };

        // let intervalId = setInterval(rotateImages, 150);
        // return () => clearInterval(intervalId);
    }, [images]);

    const onLoopImages = (index = 0) => {
        // console.log(images.length, !imageTrigger, (index + 1) % images.length);
        // if (
        //     images.length &&
        //     !imageTrigger &&
        //     (index + 1) % images.length !== 0
        // ) {
        //     index = (index + 1) % images.length;
        //     setImageTrigger(true);
        //     setImageDisplay(images[index].Image);
        //     return setTimeout(() => {
        //         onLoopImages(index);
        //     }, 50);
        // }

        if (!images.length)
            return setTimeout(() => {
                onLoopImages();
            }, 50);

        index = (index + 1) % images.length;
        setImageDisplay(images[index].Image);
        return setTimeout(() => {
            onLoopImages(index);
        }, 50);

        // setImageDisplay(images[0].Image);
        // return setTimeout(() => {
        //     onLoopImages();
        // }, 50);
    };

    // // Rotate through pre-fetched images
    // useEffect(() => {
    //     let i = 0;
    //     const rotateImages = () => {
    //         if (preFetchedImages.length > 0) {
    //             setImageRotate(preFetchedImages[i]);
    //             i = (i + 1) % preFetchedImages.length;
    //             console.log(i);
    //         }
    //     };
    //     const intervalId = setInterval(rotateImages, 50);
    //     return () => clearInterval(intervalId);
    // }, [preFetchedImages]);

    // useEffect(() => {
    //     let i = 0;
    //     let imageLength = imageSrc?.length;

    //     let clonedImageSrc = [...imageSrc];
    //     console.log(clonedImageSrc);

    //     clonedImageSrc.sort((a, b) => {
    //         if (a.attributes.name < b.attributes.name) return -1;
    //         if (a.attributes.name > b.attributes.name) return 1;
    //         return 0;
    //     });

    //     const rotateImages = () => {
    //         setImageRotate(getStrapiMedia(clonedImageSrc[i].attributes.url));
    //         i = (i + 1) % imageLength;
    //     };

    //     let intervalId = setInterval(rotateImages, 150);
    //     return () => clearInterval(intervalId);
    // }, []);

    return (
        <section
            className={`relative padded-section bg-midGrey bg-cover bg-no-repeat pt-16 lg:pt-[5.125vw] ${
                floatingImage ? "pb-36 lg:pb-[26vw]" : "lg:pb-[18vw]"
            } `}
            ref={floatingImageSectionRef}
        >
            <TextContainer
                serviceName={null}
                header={data.header}
                description={data.description}
                className={" pb-12"}
                extraMargin={false}
            />

            <div className="flex flex-col lg:flex-row">
                <div className="flex flex-col justify-center lg:order-1 lg:flex-1">
                    {introCard1To3.map((card: any, index: number) => (
                        <BoxContent
                            key={index}
                            title={card.title}
                            para={card.description}
                        />
                    ))}
                </div>

                <div className="flex w-5/6 sm:w-1/2 m-auto mb-8 -order-1 lg:order-2 lg:flex-[1.2] lg:mb-0 lg:m-0">
                    {/* {imageRotate && (
                        <Image
                            // src={imageSrc}
                            src={imageRotate}
                            width={460}
                            height={460}
                            alt={""}
                            className="w-[90%] h-auto object-contain m-auto "
                        />
                    )} */}
                    {/* {imageDisplay} */}
                    <Image
                        src="/ufo-gif.webp"
                        width={460}
                        height={460}
                        alt={""}
                        className="w-[90%] h-auto object-contain m-auto "
                        loading="lazy"
                        unoptimized
                    />
                </div>

                <div className="flex flex-col justify-center lg:order-3 lg:flex-1">
                    {introCard4To6.map((card: any, index: number) => (
                        <BoxContent
                            key={index}
                            title={card.title}
                            para={card.description}
                        />
                    ))}
                </div>
            </div>

            {/* Floating Image */}
            <div
                className="absolute z-20 left-0 bottom-0 min-w-72 w-[36vw] opacity-0 translate-y-8"
                ref={floatingImgRef}
            >
                <Image
                    src={floatingImage}
                    width={460}
                    height={460}
                    alt={""}
                    className="w-full"
                    loading="lazy"
                />
            </div>

            <BottomCurves color="light grey" direction="left" />
        </section>
    );
}
